import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { DataWithPaginationInterface } from 'shared/types/pagination-interface'
import useSWR from 'swr'
import { INTEGRATIONS_API } from '../api'
import { IntegrationInterface } from '../types'

export const useIntegrations = () => {
  const { user } = useUser()
  const { fetcher: fetchIntegrations } = useFetch<
    RequestMethodsEnum.get,
    DataWithPaginationInterface<IntegrationInterface>
  >({
    method: RequestMethodsEnum.get,
  })

  const { data, mutate } = useSWR(
    () => user && `${INTEGRATIONS_API}/zoom-integration/user/integrations`,
    fetchIntegrations,
  )

  return { data, mutate }
}
